<template>
  <v-navigation-drawer
    app
    right
    clipped
    width="290"
    v-model="model"
  >
    <perfect-scrollbar style="height: 100%">
      <div class="mt-4 mx-2" >
        <date-selection />
        <status-selection />
      </div>
    </perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DateSelection from './filters/DateSelection.vue';
import StatusSelection from './filters/StatusSelection.vue';

export default {
  name: 'AlertDrawer',
  components: {
    DateSelection,
    StatusSelection,
  },
  computed: {
    ...mapState('alerts', ['drawer']),
    model: {
      get() {
        return this.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
  methods: {
    ...mapMutations('alerts', ['setDrawer']),
  },
};
</script>
